import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Input } from 'antd';
import cn from 'classnames';
import { messageAreaStateSelector } from '../../store/selectors';
import { messageAreaMaxCount } from '../../constants/common';
import { setMessageAreaState } from '../../store/actions';
import styles from './MessageArea.module.scss';

const { TextArea } = Input;

const MessageArea = ({ className, disabled }) => {
  const dispatch = useDispatch();
  const value = useSelector(messageAreaStateSelector);

  const handleChange = (e) => {
    const val = e.target.value;
    const text =
      val.length <= messageAreaMaxCount
        ? val
        : val.slice(0, messageAreaMaxCount);

    dispatch(setMessageAreaState(text));
  };

  return (
    <TextArea
      className={cn(styles.root, className)}
      autoSize={{ maxRows: 5 }}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder={`Если текст больше ${messageAreaMaxCount} символов, используйте редактор`}
    />
  );
};

export default MessageArea;
